const sStatusDef: Record<string, string> = {
  pending: '<span class="far fa-meh text-accent-a2" title="Pending"></span>',
  scheduled: '<span class="far fa-meh text-accent-a2" title="Scheduled"></span>',
  unknown: '<span class="far fa-meh text-accent-a2" title="Unknown"></span>',
  enroute: '<span class="far fa-meh text-accent-a2" title="Enroute"></span>',
  delivered: '<span class="far fa-smile text-success-s2" title="Delivered"></span>',
  expired: '<span class="far fa-frown text-error-r3" title="Expired"></span>',
  deleted: '<span class="far fa-frown text-error-r3" title="Deleted"></span>',
  undeliverable: '<span class="far fa-frown text-error-r3" title="Undeliverable"></span>',
  accepted: '<span class="far fa-meh text-accent-a2"  title="Accepted"></span>',
  rejected: '<span class="far fa-frown text-error-r3" title="Rejected"></span>',
  skipped: '<span class="far fa-frown text-error-r3" title="Skipped"></span>',
  no_dlr_received: '<span class="far fa-frown text-accent-a2" title="No DLR received"></span>',
  partially_delivered: '<span class="far fa-smile text-accent-a2" title="Partially delivered"></span>',
  submit_sm_failed: '<span class="far fa-frown text-error-r3" title="SUBMIT_SM failed"></span>',
  def: '<span class="icon-wait spin" title="Wait"></span>',
};

const rStatusDef: Record<string, string> = {
  wait: '<span class="icon-wait spin" title="Wait"></span>',
  positive: '<span class="icon-positive text-success-s2" title="Positive"></span>',
  sender_replaced: '<span class="icon-attention text-accent-a2" title="Sender ID replaced"></span>',
  text_replaced: '<span class="icon-attention text-accent-a2" title="Text replaced"></span>',
  test_number_offline: '<span class="icon-negative text-accent-a2" title="Test number offline"></span>',
  test_number_not_available: '<span class="icon-test-number-not-available text-accent-a2" title="Test number not available"></span>',
  network_offline: '<span class="icon-network-offline text-error-r3" title="Network offline"></span>',
  not_delivered: '<span class="icon-negative text-error-r3" title="Negative"></span>',
  def: '<span class="icon-negative text-error-r3" title="Negative"></span>',
  rcs_positive: '<span class="icon-rcs-positive" title="RCS Positive"></span>',
  rcs_replaced: '<span class="icon-rcs-text-replaced" title="RCS Sender ID/Text replaced"></span>',
  flash_call_detected: '<span class="icon-flash-call" title="Flash call: SMS not received, incoming call with CLI matching the Test ID"></span>',
};

export class DlrRecStatusRenderUtils {
  static formatDlrRecStatus(testStatus: string, messageState: string, channelRaw?: string, options: { class?: string } = {}): string {
    const statuses: string[] = [];
    const status = (testStatus || '').toLowerCase();
    const state = (messageState || '').toLowerCase();
    const channel = (channelRaw || '').toLowerCase();

    if (status === 'internal_error') {
      statuses.push(
        '<span class="icon-bug-red fs-3 text-error-r3" title="Internal error happened during test execution, you won\'t be charged. Try to re-execute the test."></span>'
      );
    } else if (status === 'smpp_session_offline') {
      statuses.push('<span class="icon-smpp-connection-offline text-error-r3" title="SMPP Connection offline"></span>');
    } else {
      const sKey = sStatusDef[state] ? state : 'def';
      statuses.push(sStatusDef[sKey]);

      let rKey = rStatusDef[status] ? status : 'def';
      if (rKey === 'positive' && channel === 'rcs') rKey = 'rcs_positive';
      if ((rKey === 'sender_replaced' || rKey === 'text_replaced') && channel === 'rcs') rKey = 'rcs_replaced';
      statuses.push(rStatusDef[rKey]);
    }

    const wrapperClass = `h-100 w-fit d-flex align-items-center justify-content-center fs-2 ${options.class || ''}`;

    return `<div class="${wrapperClass}">` + statuses.join('<span class="fs-3 mx-0_2 fw-normal">/</span>') + '</div>';
  }

  static formatRecStatus(testStatus: string, channel: string) {
    const statusDef = {
      wait: '<span class="icon-wait spin" title="Wait"></span>',
      positive: '<span class="icon-positive text-success-s2" title="Positive"></span>',
      sender_replaced: '<span class="icon-attention text-accent-a2" title="Sender ID replaced"></span>',
      text_replaced: '<span class="icon-attention text-accent-a2" title="Text replaced"></span>',
      test_number_offline: '<span class="icon-negative text-accent-a2" title="Test number offline"></span>',
      test_number_not_available: '<span class="icon-test-number-not-available text-accent-a2" title="Test number not available"></span>',
      network_offline: '<span class="icon-network-offline text-error-r3" title="Network offline"></span>',
      not_delivered: '<span class="icon-negative text-error-r3" title="Negative"></span>',
      def: '<span class="icon-negative text-error-r3" title="Negative"></span>',
      internal_error:
        '<span class="icon-bug-red p-0_2" title="Internal error happened during test execution, you won\'t be charged. Try to re-execute the test."></span>',
      rcs_positive: '<span class="icon-rcs-positive" title="RCS Positive"></span>',
      rcs_replaced: '<span class="icon-rcs-text-replaced" title="RCS Sender ID/Text replaced"></span>',
      flash_call_detected: '<span class="icon-flash-call" title="Flash call: SMS not received, incoming call with CLI matching the Test ID"></span>',
    };
    let key = typeof statusDef[testStatus.toLowerCase()] !== 'undefined' ? testStatus.toLowerCase() : 'def';
    if (key === 'positive' && channel === 'rcs') {
      key = 'rcs_positive';
    }
    if ((key === 'sender_replaced' || key === 'text_replaced') && channel === 'rcs') {
      key = 'rcs_replaced';
    }
    return `<div class="h-100 fs-2  w-fit d-flex align-items-center justify-content-center">${statusDef[key]}</div>`;
  }
}
